import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  createUserVoiceToneSelectionMutation,
  deleteUserVoiceToneSelectionMutation,
} from "ProgressReportCommon/modules/ProgressReportMutations.js";
import {
  getStaffVoiceToneFromCache,
  writeStaffVoiceToneToCache,
} from "ProgressReportCommon/modules/ProgressReportGraphqlHelpers";
import { dispatchError } from "Utils";

export const createUserVoiceToneSelection = ({
  userId,
  voiceToneId,
  voiceTones,
  curriculumProgramId,
}) => {
  return async (dispatch, getState) => {
    const variables = {
      id: userId,
      filters: {
        curriculumProgramId,
      },
    };
    const aiVoiceData = getStaffVoiceToneFromCache(variables);
    const aiVoiceTone = _.get(aiVoiceData, "aiVoiceTone", {});

    try {
      await client.mutate({
        mutation: createUserVoiceToneSelectionMutation,
        variables: {
          input: {
            userId,
            voiceToneId,
            curriculumProgramId,
          },
        },
        optimisticResponse: {
          __typename: "Mutation",
          ai: {
            __typename: "AiMutations",
            createUserVoiceToneSelection: true,
          },
        },
        update: (cache, { data }) => {
          const { ai } = data;
          const isSelectedVoice = _.get(
            ai,
            "createUserVoiceToneSelection",
            false
          );
          if (isSelectedVoice) {
            const selectedVoice = _.find(voiceTones, { id: voiceToneId });
            const modifiedData = {
              id: userId,
              aiVoiceTone: selectedVoice,
            };
            setTimeout(() =>
              writeStaffVoiceToneToCache({
                variables,
                data: modifiedData,
              })
            );
          }
        },
      });
    } catch (error) {
      writeStaffVoiceToneToCache({
        variables,
        data: {
          id: userId,
          aiVoiceTone: aiVoiceTone,
        },
      });
      dispatchError({ dispatch, error });
    }
  };
};

export const deleteUserVoiceToneSelection = ({
  userId,
  voiceToneId,
  voiceTones,
  curriculumProgramId,
}) => {
  return async (dispatch, getState) => {
    const variables = {
      id: userId,
      filters: {
        curriculumProgramId,
      },
    };
    const aiVoiceData = getStaffVoiceToneFromCache(variables);
    const aiVoiceTone = _.get(aiVoiceData, "aiVoiceTone", {});

    try {
      await client.mutate({
        mutation: deleteUserVoiceToneSelectionMutation,
        variables: {
          input: {
            userId,
            curriculumProgramId,
          },
        },
        optimisticResponse: {
          __typename: "Mutation",
          ai: {
            __typename: "AiMutations",
            deleteUserVoiceToneSelection: true,
          },
        },
        update: (cache, { data }) => {
          const { ai } = data;
          const isSelectedVoice = _.get(
            ai,
            "deleteUserVoiceToneSelection",
            false
          );
          if (isSelectedVoice) {
            const selectedVoice = _.find(voiceTones, { id: voiceToneId });
            const modifiedData = {
              id: userId,
              aiVoiceTone: selectedVoice,
            };
            setTimeout(() =>
              writeStaffVoiceToneToCache({
                variables,
                data: modifiedData,
              })
            );
          }
        },
      });
    } catch (error) {
      writeStaffVoiceToneToCache({
        variables,
        data: aiVoiceTone,
      });
      dispatchError({ dispatch, error });
    }
  };
};
